<template>
  <div class="main-kyc">
    <div class="content">

      <div class="title-section">
        <h2>احراز هویت</h2>
        <p>برای انجام معامله و استفاده از امکانات دریک باید فرایند احراز هویت را تکمیل کنید. ثبت اطلاعات و احراز هویت
          شما
          نهایتا تا 2 روز کاری انجام می شود. شما می توانید از وضعیت در خواست خود در قسمت اعلانات مطلع شوید
        </p>
      </div>

      <div class="info-section">
        <div class="right-line"></div>
        <the-personal-info :data.sync="userInfo"/>
      </div>
      <div class="bank-section">
        <div class="right-line"  v-if="!state.userInfo.authorized"></div>
        <the-bank-info
            :key="change"
            :data.sync="userInfo"
            :error="duplicateBank"
            @confirmDeleteBank="submit"
            @addBank="submit"

        />
      </div>
      <div class="upload-section" v-if="!state.userInfo.authorized">
        <div class="right-line-upload"></div>
        <the-upload-doc :data.sync="userInfo" />
        <div class="submit-button-section">
          <div class="border"></div>
          <button class="blue-btn" @click="submit" :disabled="disabled">
            <span v-if="disabled">{{ disabled }}</span>

            <span v-else>ارسال</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const inputLabel = {
  firstName: "نام",
  lastName: "نام خانوادگی",
  email: "ایمیل",
  birthDay: "تاریخ تولد",
  mobileNumber: "شماره موبایل",
  telephone: "شماره ثابت",
  address: "آدرس",
  image: "عکس",
};
import ThePersonalInfo from "./the-personal-info";
import TheBankInfo from "./the-bank-info";
import TheUploadDoc from "./the-upload-doc";
export default {
  name: "the-kyc",
  components: {TheUploadDoc, TheBankInfo, ThePersonalInfo},
  data() {
    return {
      bankChange: "noop",
      profile: true,
      userInfo: {
        authenticationType: "",
        firstName: "",
        lastName: "",
        email: "",
        nationalCode: "",
        birthDay: "",
        mobileNumber: "",
        telephone: "",
        address: "",
    
        bankAccounts: [
          {
            shebaCode: "",
            cardNumber: "",
            bankName: "",
          },
        ],
        image: "",
      },
      duplicateBank: "",
      change: 0,
    };
  },
  computed: {
    disabled() {
      for (let key in this.userInfo) {
        if (
            [
              "firstName",
              "lastName",
              "email",
              "nationalCode",
              "birthDay",
              "mobileNumber",
              "telephone",
              "bankAccounts",
              "image",
            ].includes(key)
        ) {
          if (key === "bankAccounts") {
            if (this.userInfo.bankAccounts.length) {
              for (let data of this.userInfo.bankAccounts) {
                if (
                    !data.shebaCode ||
                    !data.cardNumber ||
                    data.cardNumber.replace(/-/g, "").length < 16
                ) {
                  return "اطلاعات بانکی اشتباه است";
                }
              }
            } else {
              return "حداقل یک حساب بانکی اضافه نمایید";
            }
          } else if (key === "nationalCode") {
            if (this.userInfo[key] < 10) {
              return "کدملی اشتباه است";
            }
          } else if (!this.userInfo[key]) {
            return inputLabel[key] + " اجباریست";
          }
        }
      }
      return false;
    },
  },
  methods: {
    async check() {
      const res = await this.$axios("/users/account");
      this.userInfo = res.baseDTO;
      this.change++;
    },
    bankCheck(items) {
      for (let item of items) {
        if (!item.cardNumber || !item.shebaCode) {
          this.$error(
              "اطلاعات ناقص",
              "شماره شبا یا کارت بانکی را وارد نکرده اید"
          );
          return false;
        } else {
          return true;
        }
      }
    },
    dataURLtoFile(dataurl, filename) {
      let arr = dataurl.split(",");
      let mime = arr[0].match(/:(.*?);/)[1];
      let bstr = atob(arr[1]);
      let n = bstr.length;
      let u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {
        type: mime,
      });
    },
    async submit() {
      if (this.state.loading) return;
      this.state.loading = true;
      let form_data = new FormData();

      for (let key in this.userInfo) {
        if (key === "image") {
          if (typeof this.userInfo.image !== "string") {
            form_data.append("file", this.userInfo.image);
          }
          else {
            form_data.append("file", this.dataURLtoFile(this.userInfo.image, "image"));
          }
        }

        form_data.append(key, this.userInfo[key]);
      }
      form_data.append(
          "bankAccountsString",
          JSON.stringify(this.userInfo.bankAccounts)
      );

      if (this.bankCheck(this.userInfo.bankAccounts)) {
        try {
          let vm = this;
          const config = {
            onUploadProgress: function (progressEvent) {
              vm.state.progress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
              );
            },
          };
          const res = await this.$axios.post(
              "/users/account",
              form_data,
              config
          );

          this.state.userInfo.authenticationType =
              res.baseDTO.authenticationType;
          this.state.userInfo.email = res.baseDTO.email;
          this.state.userInfo.authorized =
              res.baseDTO.authenticationType === "AUTHORIZED";
          this.state.userInfo.pending =
              res.baseDTO.authenticationType === "PENDING";
          await this.$error("", "اطلاعات با موفقیت ذخیره شد", "success");

          if (res.message.includes("need to be verified")) {
            this.state.loading = true;
            await this.$axios(
                `/finotech/send-sms-to-customer?email=${this.userInfo.email}`
            );
            this.$router.push("/fino");
          } else {
            this.$getuserInfo();
          }
        } catch (e) {
          if (
              e.response &&
              e.response.data.message.includes(
                  "ShebaCode or CardNumber Is For Another User"
              )
          ) {
            this.$error("", " شماره شبا یا کارت قبلا وارد شده است.");
            this.duplicateBank = e.response.data.message;
          }
        }
      }
      this.state.loading = false;
    },
  },
  created() {
    this.check();
  },
  mounted() {
    // console.log(this.userInfo)
  },
}

</script>

<style lang="scss" scoped>
.right-line{
  height: calc(100% + 74px);
  width: 20px;
  border-right: 1px solid #D7C8C8;
  border-top: 1px solid #D7C8C8;
  border-bottom: 1px solid #D7C8C8;
  position: absolute;
  top: 34px;
  right: -21px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.right-line-upload{
  height: calc(100% - 50px);
  width: 20px;
  border-right: 1px solid #D7C8C8;
  border-top: 1px solid #D7C8C8;
  border-bottom: 1px solid #D7C8C8;
  position: absolute;
  top: 34px;
  right: -21px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
}

.main-kyc {
  background-image: url("../../assets/backgrounds/KYC.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 80px;

  .content {
    width: 85%;
    direction: rtl;
    margin-top: 100px;
    display: flex;
    flex-direction: column;
    gap: 80px;

    .info-section{
      display: flex;
      flex-direction: column;
      position: relative;
    }

    .bank-section{
      display: flex;
      flex-direction: row;
      position: relative;
    }

    .upload-section{
      display: flex;
      flex-direction: column;
      position: relative;

      .submit-button-section{
        display: flex;
        justify-content: flex-end;
        width: 100%;
        position: relative;

        .border{
          border-bottom: 1px solid #D7C8C8;
          position: absolute;
          width: 80%;
          right: 0;
          top: 60%;
        }
        
        button{
          width: 20%;
          height: 38px;
        }
      }
    }


    .title-section {
      display: flex;
      flex-direction: column;
      color: #FFFFFF;
      text-align: right;
      align-items: flex-start;
      p{
        width: 80%;
      }
    }
  }


}
</style>